module.exports = __webpack_public_path__ + "static/img/loginbanner.dfff2326.png";